import { ApiService } from 'js/src/client';
import {
    markAnnouncementViewed,
    setAnnouncementsUnreadCount,
    setLoadingAnnouncements,
    storeAnnouncements,
} from 'js/src/data/announcements/announcement-actions';
import { ImmutableFromJS } from 'js/src/libs/consts';
import type { AppDispatch } from 'js/src/libs/RootState';

type LoadAnnouncementsOptions = {
    currentUrl?: string;
};

export function loadAnnouncements(options: LoadAnnouncementsOptions = {}) {
    return async (dispatch: AppDispatch) => {
        dispatch(setLoadingAnnouncements({ isLoading: true }));
        try {
            const response = await ApiService.announcementsList({
                query: {
                    url: options.currentUrl,
                },
            });
            const data = Array.isArray(response.data) ? response.data : [];
            dispatch(
                storeAnnouncements({
                    announcements: ImmutableFromJS(data),
                }),
            );
        } catch (error) {
            analytics.track('Announcement Load Failed', { error: String(error) });
        } finally {
            dispatch(setLoadingAnnouncements({ isLoading: false }));
        }
    };
}

let unreadCountPromise: Promise<void> | null = null;

export function loadAnnouncementsUnreadCount() {
    return async (dispatch: AppDispatch) => {
        if (unreadCountPromise) {
            return unreadCountPromise;
        }
        unreadCountPromise = (async () => {
            try {
                const response = await ApiService.announcementsUnreadCountRetrieve();
                dispatch(
                    setAnnouncementsUnreadCount({
                        count: response.data.unread_count,
                    }),
                );
            } catch (error) {
                analytics.track('Announcement Unread Count Load Failed', {
                    error: String(error),
                });
            } finally {
                unreadCountPromise = null;
            }
        })();
        return unreadCountPromise;
    };
}

export function markAnnouncementAsViewed(announcementId: number) {
    return async (dispatch: AppDispatch) => {
        dispatch(markAnnouncementViewed({ announcementId }));
        try {
            await ApiService.announcementsMarkViewedCreate({
                body: {
                    announcement_id: announcementId,
                },
            });
        } catch (error) {
            analytics.track('Announcement Mark Viewed Failed', {
                announcement_id: announcementId,
                error: String(error),
            });
        }
    };
}

export function trackAnnouncementCtaClick(announcementId: number) {
    return async (dispatch: AppDispatch) => {
        try {
            await ApiService.announcementsMarkClickedCreate({
                body: {
                    announcement_id: announcementId,
                },
            });

            analytics.track('Announcement CTA Clicked', {
                announcement_id: announcementId,
            });
        } catch (error) {
            analytics.track('Announcement CTA Click Failed', {
                announcement_id: announcementId,
                error: String(error),
            });
        }
    };
}
